"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionList = exports.ErrorBoxContainer = exports.RightContainer = exports.LeftContainer = exports.ModalTopButtonGroup = exports.ModalTopButtonGroupContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var common_1 = require("../common");
var QuestionTable_1 = require("./QuestionTable");
exports.ModalTopButtonGroupContainer = styled_components_1.default.div.attrs({
    className: 'btn-group-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t&.btn-group-container {\n\t\twidth: 100%;\n\t}\n"], ["\n\t&.btn-group-container {\n\t\twidth: 100%;\n\t}\n"])));
exports.ModalTopButtonGroup = (0, styled_components_1.default)(aon_tws_common_ui_1.ButtonGroup).attrs({})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n\tmargin-bottom: 30px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 30px;\n\tmargin-bottom: 30px;\n"])));
exports.LeftContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.RightContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\t.btn {\n\t\t\tmargin-left: 0;\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n"], ["\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\t.btn {\n\t\t\tmargin-left: 0;\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n"])));
var TableContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tmin-height: 275px;\n"], ["\n\tmin-height: 275px;\n"])));
TableContainer.displayName = 'TableContainer';
var hiddenContainerStyle = {
    width: '0',
    opacity: 0,
    overflow: 'hidden',
    height: '0',
};
exports.ErrorBoxContainer = styled_components_1.default.div.attrs({})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tmargin-bottom: 40px;\n\t", "\n\ttext-align: left;\n"], ["\n\tmargin-bottom: 40px;\n\t", "\n\ttext-align: left;\n"])), function (props) { return (props.hasDimensionSelector ? '' : 'margin-top: 40px;'); });
var QuestionList = /** @class */ (function (_super) {
    __extends(QuestionList, _super);
    function QuestionList(props) {
        var _this = _super.call(this, props) || this;
        _this.applyPrimaryFilterSelection = _this.applyPrimaryFilterSelection.bind(_this);
        return _this;
    }
    QuestionList.prototype.render = function () {
        var _a = this.props, createQuestionButtons = _a.createQuestionButtons, loading = _a.loading, primaryFilterOptions = _a.primaryFilterOptions, selectedFilterOption = _a.selectedFilterOption;
        var selectedMajorFilterOption = primaryFilterOptions.length > 0 ? selectedFilterOption.name : undefined;
        return (React.createElement(React.Fragment, null,
            loading ? (React.createElement(common_1.LoadingWrapper, null,
                React.createElement(aon_tws_common_ui_1.Loading, { height: '70px', width: '70px' }))) : null,
            React.createElement("div", { style: loading ? hiddenContainerStyle : undefined },
                React.createElement(exports.ModalTopButtonGroupContainer, null,
                    React.createElement(exports.ModalTopButtonGroup, null,
                        React.createElement(exports.LeftContainer, null, primaryFilterOptions.length > 0 && (React.createElement(aon_tws_common_ui_1.Select, { items: primaryFilterOptions, size: 'lg', dropdownSize: 'lg', selectedValue: selectedFilterOption.name, onApply: this.applyPrimaryFilterSelection }))),
                        React.createElement(exports.RightContainer, null, createQuestionButtons))),
                this.checkSelectionThreshold(),
                React.createElement(QuestionTable_1.QuestionTable, __assign({}, this.props, { selectedMajorFilterOption: selectedMajorFilterOption })))));
    };
    QuestionList.prototype.applyPrimaryFilterSelection = function (value) {
        var selectedOption = this.props.primaryFilterOptions.find(function (o) { return o.name === value; }) || this.props.primaryFilterOptions[0];
        this.props.ApplyPrimaryFilter(selectedOption);
    };
    QuestionList.prototype.checkSelectionThreshold = function () {
        var _a = this.props, selectionThreshold = _a.selectionThreshold, selectionThresholdExceedText = _a.selectionThresholdExceedText, totalSelectedQuestions = _a.totalSelectedQuestions;
        var showError = selectionThreshold !== undefined && totalSelectedQuestions > selectionThreshold;
        return (React.createElement(exports.ErrorBoxContainer, { hasDimensionSelector: true },
            React.createElement(common_1.ErrorMessage, { message: selectionThresholdExceedText, show: showError, showIcon: true })));
    };
    return QuestionList;
}(React.PureComponent));
exports.QuestionList = QuestionList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
